import React, { useEffect, useState } from 'react';
import { Container, Row,Card, CardBody } from "react-bootstrap";
import { Button, message, Table,Input,Typography,Col,Tag, Avatar } from 'antd';
import { UserOutlined, CalendarOutlined,  MessageOutlined, SendOutlined, PlusOutlined  } from '@ant-design/icons';


import UseApiService from './../../services/Api.service'
import * as constants from './../../constants/constants';


import { MailOutlined,EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Search } = Input;
const { Title, Text, Paragraph } = Typography;


export default function NewslettersPage({handleUrl}){
  const [loading,setLoading] = useState(false);  
  const [selectedRowKey, setSelectedRowKey] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  

  const [searchValue,setSearchValue] = useState();  
  const [filteredData, setFilteredData] = useState([]);
  const [data,setData] = useState();
  const [rowSelected,setRowSelected]= useState(null);
  const [experiencieSelected,setExperienceSelected]= useState(null);
  //const [columns,setColumnns] = useState();
  const [wizardVisible, setWizardVisible] = useState(false);

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  
  const navigate = useNavigate();

  const columns = [
      {
        title: 'Newsletter',
        dataIndex: 'title',
        render:(text) =>(
          <span className="fs-6">{text}</span>
        )
      },
      {
        title: 'Fecha',
        dataIndex: 'date',
        width:160,
        render:(text) =>(
          <>{text}</>
        )
      },
      {
        title: '',
        dataIndex: 'id',
        width:100,
        render:(text,record) =>(
          <>
            <Button color="primary" variant="outlined" onClick={(event)=>{
                event.stopPropagation();//Para que no se expanda el row
                sendEmarsys(record.site,record.id,record.listid,record.title);
              }}
            >
              Enviar a Emarsys <SendOutlined />
            </Button>
          </>
        )
      }
    ];

  useEffect(()=>{
    getData();    
  },[]);  

  function getData(){
    const url = constants.API_NewslettersList;
    //const url = constants.U_API2+'?opt=nws';
    
    setLoading(true);
    UseApiService(url,{method:'GET'})
    .then(({data,error}) =>{
      if(error){        
        message.error('Ocurrio un error: '+error);
      }
      else{
        let resp = Array.isArray(data.newsletters) ? data.newsletters : [data.newsletters];
        setData(resp);
      }
    })
    .catch((e)=>{
      console.log(e);
      message.error('Ocurrio un error:'+e);
    })
    .finally((e)=>{
      setLoading(false);
    });    
  }

  function createNewsletter(){
    const url = constants.API_NewslettersNew;
    //const url = constants.U_API2+'?opt=addnws';
    
    setLoading(true);
    UseApiService(url,{method:'POST',
      body: { }
    })
    .then(({data,error}) =>{
      if(error){        
        message.error('Ocurrio un error: '+error);
      }
      else{
        getData()
      }
    })
    .catch((e)=>{
      console.log(e);
      message.error('Ocurrio un error:'+e);
    })
    .finally((e)=>{
      setLoading(false);
    });    
  }

  function sendEmarsys(site,id,idEmarsys,name){
    const url = constants.API_Emarsys;
    
    setLoading(true);
    UseApiService(url,{method:'POST',
      body: {
        site : site,
        newsletterId : id, 
        listId: idEmarsys,
        name : name
      }
    })
    .then(({data,error}) =>{
      if(error){        
        message.error('Ocurrio un error: '+error);
      }
      else{
        getData();
        if(data.message){
          message.info(data.message);
        }
      }
    })
    .catch((e)=>{
      console.log(e);
      message.error('Ocurrio un error:'+e);
    })
    .finally((e)=>{
      setLoading(false);
    });    
  }

  const rowClassName = (record) => {
    return record.key === selectedRowKey ? 'selected-row' : '';
  };

  const handleRowClick = (record) => {
    setSelectedRowKey(record.id);
    setExpandedRowKeys((prevKeys) => {
      const isExpanded = prevKeys.includes(record.id);
      if (isExpanded) {
        return prevKeys.filter((key) => key !== record.id); // colapsar
      } else {
        return [...prevKeys, record.id]; // expandir
      }
    });
  };

  function handleCreateNew(){
    createNewsletter();
  }


  return(
    <Container className="content">
      <Row>
        <span className='h3 mt-1 text-black'><MailOutlined /> Newsletters</span>
      </Row>
      <Row className='mt-3'>
        <Card border='light'>
          <Card.Body>        
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>          
              <Search
                placeholder="Busca sitio"
                /*onSearch={handelSearch}*/
                enterButton
                style={{ width: 280 }}
                loading={loading}
              />                
              <Button 
                type="primary" 
                icon={<PlusOutlined />} 
                iconPosition="start"
                loading={loading}
                onClick={handleCreateNew}
              >
                Crear Newsletter
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Row>
      <Row>
        <Card className="mt-4" border='light'>
          <Card.Body>
            <Table 
              rowKey="id"
              columns={columns} 
              dataSource={data} 
              rowClassName={rowClassName}
              loading={loading}
              onRow={(record) => ({
                onClick: () => handleRowClick(record), 
              })}
              size="small"
              pagination={{ pageSize: 10 }}
              expandable={{
                expandedRowRender: (record) => (
                  <DataList data={record.articles} />
                ),
                rowExpandable: (record) => record.name !== 'Not Expandable',
                expandedRowKeys: expandedRowKeys,
                onExpandedRowsChange: (newKeys) => setExpandedRowKeys(newKeys),
              }}
            />
          </Card.Body>
        </Card>      
      </Row>
    </Container>      
  )
}

const DataList = ({ data }) => {  
  if (!data || data.length === 0) {
    return <p>No hay datos disponibles.</p>;
  }

 return (
    <div style={{padding:'20px'}}>
      {data.map((item) => {
        const {
          img,
          title,
          subtitle,
          summary1,
          author,
          category1,
          publisheddate,
          pageviews,
          comments,
          url,
          idarticulo,
        } = item;

        return (
          <Card
            key={idarticulo}
            style={{
              marginBottom: 16,
              borderRadius: 8,
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
            }}
          >
            <CardBody>
            <Row gutter={16}>
              <Col xs={24} sm={6}>
                <img
                  src={img}
                  alt={title}
                  style={{
                    width: '100%',
                    height: 'auto',
                    borderRadius: 6,
                    objectFit: 'cover',
                  }}
                />
              </Col>

              <Col xs={24} sm={18}>
                <Row>
                  <Col>
                    <Tag color="blue">
                      {category1}
                    </Tag>
                  </Col>
                </Row>

                <Title level={5} className='my-2'>
                  <a href={url} target="_blank" rel="noopener noreferrer">
                    {title}
                  </a>
                </Title>

                <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>
                  {subtitle}
                </Text>

                <Paragraph ellipsis={{ rows: 2 }} style={{ marginBottom: 12 }}>
                  {summary1}
                </Paragraph>

                <Row justify="space-between" align="left">
                  <Col>
                    <Avatar
                      size="small"
                      icon={<UserOutlined />}
                      style={{ marginRight: 6 }}
                    />
                    <Text strong>{author}</Text>
                  </Col>
                  <Col className='mt-2'>
                    <Text type="secondary" style={{ marginRight: 16 }}>
                      <CalendarOutlined />{' '}
                      {new Date(publisheddate).toLocaleDateString()}
                    </Text>
                    <Text type="secondary" style={{ marginRight: 16 }}>
                      <EyeOutlined /> {pageviews}
                    </Text>
                    <Text type="secondary">
                      <MessageOutlined /> {comments}
                    </Text>
                  </Col>
                </Row>
              </Col>
            </Row>
            </CardBody>
          </Card>
        );
      })}
    </div>
  );
};